// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"theme__snackbar___33MRN","accept":"theme__accept___I_Pq1","button":"theme__button___psiy3","warning":"theme__warning___29XlW","cancel":"theme__cancel___1C-_T","active":"theme__active___1U6m8","label":"theme__label___2EWLb"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/snackbar/theme.scss
// module id = 524
// module chunks = 0